/** Learner position dto. */
export class LearnerPositionDto {
  constructor(dto) {
    this.id = dto.id;
    this.name = dto.name;
    this.language = dto.language;
  }
}
